import axios from 'axios';
import { useEffect, useRef, useState } from 'react'
import { useShowMessages } from '../useMessages/useMessages';
import { useCryptoSessionStorage } from '../useCryptoSessionStorage';

const useFetchData = (url, params = {}, changed, admin, atualizacoes, keepData) => {
    const [data, setData] = useState([]);
    const [msg, setMsg] = useState('');
    const [error, setError] = useState([]);
    const { ShowMessage } = useShowMessages();
    const [loading, setLoading] = useState(false);
    const { getData: getDataSession } = useCryptoSessionStorage();
    const lastDataRef = useRef(null);


    const type =  (admin) ? 'user' : 'client';
    const token = (admin) ? getDataSession('userToken') : getDataSession('clientToken');
    const tokenAtt = getDataSession("userTokenAtt") || '';

    let Authorization = JSON.stringify({
      token: token,
      type: type,
    });

    if(atualizacoes){
      Authorization = `Bearer ${tokenAtt}`;
    }
    
     useEffect( () => {
        // Sem url o hook serve só para post/edit/delete: não dispara o GET inicial
        if(!url) return;
        if(!keepData){
          setData([]);
          lastDataRef.current = null;
        }
        setLoading(true);
         axios.get(url, { 
          params:  params,
          headers: {'Authorization': Authorization}
        })
        .then((response) => {
          const serialized = JSON.stringify(response.data);
          if (serialized !== lastDataRef.current) {
            lastDataRef.current = serialized;
            setData(response.data);
          }
        })
        .catch(function (error) {
          if (error.response) {
            if(error.response.status === 401){
              // ShowMessage('warning', 'Sessão Expirada', 'Você será direcionado para a tela de login!')
              // .then(() => {handleSignOut()});
            }
            setError(error);
          }
        }) 
        .finally(() => {
          setLoading(false); 
        })
      }, [url, changed]);

      const getData = async(url, params) => {
        setLoading(true);
        await axios.get(url, { params:  params})
        .then((response) => {
          return setData(response.data);
        })
       .catch(function (error) {
         if (error.response) {
           if(error.response.status === 401){
           }
           console.log(error)
           return  setError(error);
         }
       })
       .finally(() => {
        setLoading(false);
       }) 
      }

      const getDataDirectly = async(urlGet, paramsGet, callback) => {
        setLoading(true);
        await axios.get(urlGet, { params:  paramsGet})
        .then((response) => {
         return callback(response.data);
        })
        .catch(function (error) {
          if (error.response) {
            if(error.response.status === 401){
            }
            return  setError(error);
            console.log(error)
          }
        })
        .finally(() => {
          setLoading(false);
        }) 
      };
      
      const getDataDirectlyPost = async(urlGet, data, callback) => {
        setLoading(true);
        await axios.post(urlGet, data)
        .then((response) => {
         return callback(response.data);
        })
        .catch(function (error) {
          if (error.response) {
            if(error.response.status === 401){
            }
            return  setError(error);
            console.log(error)
          }
        })
        .finally(() => {
          setLoading(false);
        }) 
      }    

      const editData = async(url, data) => {
            setLoading(true);
            return await axios.put(url, data)
            .then((response) => {
              return({
                success: true,
                msg: response.data.message
              })
            })
            .catch((error) => {
              if(error.response.data) {
                return({  success: false, msg: error.response.data.message })
              } 
              else {return({ success: false, msg: 'Ocorreu um erro ao salvar' })}              
            }) 
            .finally(() => {
              setLoading(false);
            }) 
      }

      

    const postData = async(url, data) => {
      setLoading(true);
      return await axios.post(url, data, { 
        headers: {'Authorization': Authorization}
      })
      .then((response) => {
        setMsg(response.message);
        return({
          success: true,
          msg: response.data.message,
          id: response.data?.results?.insertId,
          data: response.data
        })
      })
      .catch(function (error) {
        console.log(error?.response || error)
        const message = error?.response?.data?.message || 'Ocorreu um erro ao salvar';
        return({
          success: false,
          msg: message
        })
      }) 
      .finally(() => {
        setLoading(false); 
      })
  }    

  const deleteData = async(url, params) => {
    setLoading(true);
    return await axios.delete(url, { params: params })
    .then((response) => {
      setMsg(response.message);
      return({
        success: true,
        msg: 'Registro deletado com sucesso'
      })
    })
    .catch(function (error) {
      console.log(error.response)
      if(error.response.data.message) {
        return({
          success: false,
          msg: error.response.data.message
        })
      } else {
        return({
        success: false,
        msg: 'Ocorreu um erro ao salvar'
      })}
    }) 
    .finally(() => {
      setLoading(false);
    })
}   

  return {data, error, editData, postData, deleteData, msg, getData, getDataDirectly, loading, setLoading, getDataDirectlyPost}

}

export {useFetchData}
